import React from "react";
import "./Button.scss";

function Button({ label, onClick, type = "primary", className = "" }) {
    const playSound = (soundPath) => {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audio = new Audio(soundPath);
        const track = audioContext.createMediaElementSource(audio);
        track.connect(audioContext.destination);

        audioContext.resume().then(() => {
            audio.volume = 0.3;
            audio.play();
        });
    };

    const handleClick = () => {
        playSound("/sounds/click.mp3");
        if (onClick) onClick();
    };

    const handleHover = () => {
        playSound("/sounds/hover.mp3");
    };

    return (
        <button 
            className={`btn btn-${type} ${className}`} 
            onClick={handleClick} 
            onMouseEnter={handleHover}
        >
            {label}
        </button>
    );
}

export default Button;
